import { Link } from 'react-router-dom'
import { reviews } from '../data/reviews'
import { WA_NUMBER, WA_DISPLAY, WA_MESSAGES } from '../constants'

export default function UtilityBar() {
  const rated = reviews.filter(r => r.rating)
  const avg = rated.length ? rated.reduce((sum, r) => sum + r.rating, 0) / rated.length : 5
  const avgDisplay = avg.toFixed(1)

  return (
    <div className="utility-bar" style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '8px 5%',
      background: 'var(--stone)',
      borderBottom: '1px solid var(--stone-mid)',
      fontSize: '12px',
      color: 'var(--ink-mid)',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <span style={{ color: 'var(--color-accent-cool)', fontSize: '11px', letterSpacing: '1px' }}>
          {'★'.repeat(Math.round(avg))}
        </span>
        <span>{avgDisplay}/5 · {reviews.length} reviews</span>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
        <Link to="/#treks" style={{ color: 'var(--ink-mid)' }}>Search treks</Link>
        <a
          href={`https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(WA_MESSAGES.general)}`}
          target="_blank" rel="noreferrer"
          style={{ color: 'var(--green)', fontWeight: 500 }}
        >
          WhatsApp: {WA_DISPLAY}
        </a>
      </div>
    </div>
  )
}
